import { render, staticRenderFns } from "./TeamGramChannelDashboard.vue?vue&type=template&id=3b6756da&scoped=true"
import script from "./TeamGramChannelDashboard.vue?vue&type=script&lang=js"
export * from "./TeamGramChannelDashboard.vue?vue&type=script&lang=js"
import style0 from "./TeamGramChannelDashboard.vue?vue&type=style&index=0&id=3b6756da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6756da",
  null
  
)

export default component.exports